const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001'
const CHECK_UID_ENDPOINT = import.meta.env.VITE_CHECK_UID_ENDPOINT || '/check-uid'

export const checkUID = async (uid) => {
  try {
    const response = await fetch(`${API_BASE_URL}${CHECK_UID_ENDPOINT}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + import.meta.env.VITE_SUPABASE_ANON_KEY, 
      },
      body: JSON.stringify({ uid }),
    })

    const data = await response.json()

    if (response.ok && data.valid === true) {
      return {
        success: true,
        status: response.status,
        data: data,
        message: 'UID erfolgreich validiert.',
        type: 'valid'
      }
    } else if (response.ok && data.valid === false) {
      return {
        success: false,
        status: response.status,
        data: data,
        message: 'UID ist ungültig.',
        type: 'invalid'
      }
    } else {
      return {
        success: false,
        status: response.status,
        data: null,
        message: response.status === 404 ? 'UID nicht gefunden.' : 'Fehler bei der Validierung.',
        type: 'error'
      }
    }
  } catch (error) {
    console.error('API Error:', error)
    return {
      success: false,
      status: 0,
      data: null,
      message: 'Netzwerkfehler - Bitte versuchen Sie es erneut',
      type: 'error'
    }
  }
}

export const validateUIDFormat = (uid) => {
  // Einfache UID-Format-Validierung für deutsche UIDs
  // Format: DE123456789 oder ATU12345678
  const uidRegex = /^[A-Z]{2}[0-9A-Z]{8,12}$/
  return uidRegex.test(uid?.trim())
}
